import { defineStore } from 'pinia';

import { useCapacityStore } from '@/features/capacities/capacityStore';
import { WorkerThresholdExceededAlert } from '@/features/capacities/types';
import { useCollisionStore } from '@/features/collisions/collisionStore';
import { Collision } from '@/features/collisions/types';

export const useScheduleAlertStore = defineStore('schedule-alert-store', () => {
  const collisionStore = useCollisionStore();
  const capacityStore = useCapacityStore();
  const scheduleAlerts = computed(() => {
    const alerts: Map<string, Collision | WorkerThresholdExceededAlert> = new Map();

    collisionStore.collisionsList.forEach((collision) => {
      alerts.set(collision.dependencyId, collision);
    });

    capacityStore.workerThresholdExceededAlertList.forEach((alert) => {
      alerts.set(alert.id, alert);
    });

    return alerts;
  });

  const scheduleAlertList = computed(() => {
    return Array.from(scheduleAlerts.value.values());
  });

  return {
    scheduleAlerts,
    scheduleAlertList,
  };
});
